import actions from '../../actionTypes';

export default (data) => {
  return {
    type: actions.LINK_VIEWED,
    data
  }
}


// WEBPACK FOOTER //
// ./src/reducers/users/actions/viewedUserLink.js